module.exports.SHOW_DEBUG_MESSAGES = false;
module.exports.BUILD_REAL_SERVER = true;